module.exports = __webpack_public_path__ + "img/win.796d17bd.png";